import * as ACTION_TYPES from '../types';

let initialState = {
  projectRoleList: [],
  projectRole: {},
  roles: []
}

export default (state = initialState, action) => {
    switch (action.type) {

      case ACTION_TYPES.GET_PROJECTROLES:
        return {...state, projectRoleList: action.data };

      case ACTION_TYPES.GET_ROLES:
        return {...state, roles: action.data };

      case ACTION_TYPES.GET_PROJECTROLES_BY_USERID:
        return {...state, projectRoleList: action.data };

      case ACTION_TYPES.DELETE_PROJECTROLE:
        let newList = state.projectRoleList.filter(projectRole => projectRole._id !== action.id);
        return {...state, projectRoleList: newList };

      case ACTION_TYPES.GET_PROJECTROLE_BY_ID:
        return {...state, projectRole: action.data};

      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };

      case ACTION_TYPES.DONE:
        return {...state, loading: false };

      case ACTION_TYPES.RESET_PROJECTROLES:
        return {...state, projectRoleList: []};

      case ACTION_TYPES.GET_PROJECTROLE_BY_QUERY:
        return {...state, projectRoleList: action.data}

      default:
        return state;
    }
  };